'use client'

import { useHelpWidget } from '@/app/_plugins/HelpWidget'

const ChatLink = ({ children, className }) => {
    const { openWidget } = useHelpWidget()

    return (
        <button
            onClick={() => openWidget()}
            className={className}
        >
            {children}
        </button>
    )
}

export default ChatLink
